import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./moldesCapabilities.css"
import React, { useState, useEffect, useCallback } from 'react'
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import logoMoldesCapabilities from "../../imagens/logos/logoMolds.png"
import { Link } from "react-router-dom"

const MoldesCapabilities = ({ moldesList }) => {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const nextSlide = useCallback(() => {
        slideNumber + 1 === moldesList.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, moldesList.length])

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(moldesList.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, moldesList.length])
    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);
    return (
        <div>
            {
                openModal &&
                <div className="moldesSliderWrap">
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="moldesBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="moldesBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="moldesBtnClose" onClick={() => handleCloseModal()} />
                    <img className="moldesFullScreen" src={moldesList[slideNumber].img} alt="moldes" />
                </div>
            }

            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoMoldesCapabilities} alt='logoMoldes' />
            </div>
            <div className="moldesGalleryWrap mx-2">
                {
                    moldesList && moldesList.map((image, index) => {
                        return (
                            <div
                                className="moldesSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="moldes" />
                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/ToolingAndManufacturing">
                    <button className="stampingToolButton">Back to tollings design and manufacturing</button>
                </Link>
            </div>
        </div>
    )
}

export default MoldesCapabilities